export const SMS_CODE_TYPE_ENTER: number = 1;
export const SMS_CODE_TYPE_CONFIRMATION: number = 2;
export const SMS_CODE_TYPE_FEEDBACK: number = 3;
export const SMS_CODE_TYPE_COMPLAINT: number = 4;

export const SMS_CODE_RESEND_SECONDS: number = 59;
